import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ImgBgSection from "../../../../components/NewAcademicUser/Dashboard/ImgBgSection/ImgBgSection";

import DashboardFaq from "../../../../components/NewAcademicUser/Dashboard/Faq/Faq";
import NavForSelfPacedUser from "../../../../components/NewAcademicUser/Dashboard/Nav/NavForSelfPacedUser";
import "./index.scss";
import BannerText from "./BannerText";
import useMediaQuery from "../../../../hooks/MediaQuery";
import VideoTourCard from "../VideoTourCard/VideoTourCard";
import QuickLinks from "../../../../components/NewAcademicUser/Dashboard/QuickLinks/QuickLinks";
import { useAppDispatch } from "../../../../store/store";
import { loadUser } from "../../../../store/features/Auth/AuthApi";
import ProgressSection from "../../../../components/NewAcademicUser/Dashboard/ProgressSection/ProgressSection";
import SprintSection from "../../../../components/NewAcademicUser/Dashboard/SprintSection/SprintSection";
import MobileViewSprint from "../../../../components/NewAcademicUser/Dashboard/SprintSection/MobileViewSprint";

const SelfPacedUserDashboard = () => {
  const navigate = useNavigate();
  const [authFail, setAuthFail] = useState(false);
  const dispatch = useAppDispatch();

  const smDevice = useMediaQuery(1000);
  // useLayoutEffect(() => {
  //   dispatch(loadUser({ setAuthFail: setAuthFail }));
  // }, []);
  // useEffect(() => {
  //   if (authFail) {
  //     navigate("/");
  //   }
  // }, [authFail]);
  return (
    <div>
      <div>
        <NavForSelfPacedUser  navbg navBgColorHandle/>
        <div className="product__manager__user__wrapper__div">
          <ImgBgSection />
          <div className="product__manager__user__padding__wrapper">
            <BannerText />
          </div>
          {smDevice && <VideoTourCard />}
          <div className="sprint__padding">
            <div className="video__sprint__wrapper">
              <SprintSection />
            </div>
          </div>
          <MobileViewSprint />
          <ProgressSection />
          <QuickLinks />
          <DashboardFaq />
        </div>
      </div>
    </div>
  );
};

export default SelfPacedUserDashboard;
